import { useEffect, useRef } from "react";
import axios from "axios";
import { useAssistant } from "@/lib/assistant";
import { getVisitorId } from "@/lib/tracking";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACKS = {
  exit_intent: "Before you go — wildfire prep only works if it's done before the smoke. Questions on coverage or the 2-bag discount (save CA$200)? I'm right here.",
  checkout_abandoned: "Welcome back — your order didn't complete, so nothing was charged. Want me to help you finish, or answer anything about the bundles first?",
};

export default function HesitationRescuer({ force = null }) {
  const openWith = useAssistant((s) => s.openWith);
  const fired = useRef(false);

  useEffect(() => {
    const trigger = async (context) => {
      if (fired.current || sessionStorage.getItem("noxway_rescuer_shown")) return;
      fired.current = true;
      sessionStorage.setItem("noxway_rescuer_shown", "1");
      let msg = FALLBACKS[context];
      try {
        const { data } = await axios.post(`${API}/assistant/proactive`, {
          visitor_id: getVisitorId(),
          context,
        });
        if (data.message) msg = data.message;
      } catch { /* fallback message stands */ }
      openWith(msg);
    };

    if (force) {
      const t = setTimeout(() => trigger(force), 2500);
      return () => clearTimeout(t);
    }

    // Returned from an abandoned checkout
    if (sessionStorage.getItem("noxway_checkout_started")) {
      sessionStorage.removeItem("noxway_checkout_started");
      const t = setTimeout(() => trigger("checkout_abandoned"), 2500);
      return () => clearTimeout(t);
    }

    // Exit intent: mouse leaves toward the top after 15s+ on page AND product section viewed
    const start = Date.now();
    const onLeave = (e) => {
      if (e.clientY > 0) return;
      if (Date.now() - start < 15000) return;
      if (!sessionStorage.getItem("noxway_product_viewed")) return;
      trigger("exit_intent");
    };
    document.addEventListener("mouseleave", onLeave);
    return () => document.removeEventListener("mouseleave", onLeave);
  }, [force, openWith]);

  return null;
}
